/* ============================================= *
 *    __   ___ _______  ___  ___  _______        *
 *   |  | /  /|       ||   \/   ||   _   |       *
 *   |  |/  / |   _   ||        ||  |_|  |       *
 *   |     /  |  | |  ||  |\/|  ||   _   |       *
 *   |     \  |  |_|  ||  |  |  ||  | |  |       *
 *   |  |\  \ |       ||  |  |  ||  | |  |  _    *
 *   |__| \__\|_______||__|  |__||__| |__| (_)   *
 *                                               *
 *          Copyright 2021 Eko Mardiatno         *
 *              instagram.com/komafx             *
 *               facebook.com/emrdtn             *
 *            twitter.com/ekomardiatno           *
 * ============================================= */

if (typeof jQuery === 'undefined') {
  throw new Error('Koma Plugin\'s JavaScript requires jQuery')
}